import axios from "axios";
import { cacheAdapterEnhancer } from "axios-extensions";
import { Cache } from "axios-extensions";

const cacheObj = new Cache({
  maxAge: 1000 * 60 * 6, // 6 分钟
  max: 200
});
// 创建axios实例
const service = axios.create({
  //   baseURL: "http://www.yjhuasheng.com/service",
  baseURL: window.__config.VUE_APP_BASE_API,
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 55000, // request timeout
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, {
    enabledByDefault: true,
    defaultCache: cacheObj // 重写defaultCache对象，所有请求有效
  })
});

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      const res = response.data;
      return res;
    } else {
      return Promise.reject(response.statusText);
    }
  },
  error => {
    return Promise.reject(error);
  }
);

export default service;
